
import React, { useState, useEffect } from 'react';
import { Row, Col, TabContent, TabPane, Nav, NavItem, NavLink, } from "reactstrap";
import classnames from 'classnames';
import ScrollToTop from '../../../../../common/ScrollToTop';
import PendingForApprovalKys2ListTab from './PendingForApprovalKys2ListTab';
import AwaitingForApprovalListTab from './AwaitingForApprovalListTab';
import { MESSAGES } from '../../../../../../config/message';
import { useSelector } from "react-redux";
import { checkPermission } from '../../../../../../helper';
import { PENDING_FOR_APPROVAL_KYS2_LIST, REGISTRATION_FORM_KYS2 } from '../../../../../../config/constants';

export const ApplyPendingForKys2 = React.createContext();

const PendingListKy2 = (props) => {
    // const [loading, setLoading] = useState(true); // State to manage l11oading

    const [state, setState] = useState({
        activeTab: '1',
        isOverheadForm: false,
        isProfitForm: false,
        data: {},
        ViewAccessibility: false,
        AddAccessibility: false,
        EditAccessibility: false,
        DeleteAccessibility: false,
        DownloadAccessibility: false,
        stopApiCallOnCancel: false,
        permissions: {}
    });
    // const dispatch = useDispatch();

    const topAndLeftMenuData = useSelector(state => state.auth.topAndLeftMenuData);
    const disabledClass = useSelector(state => state.comman.disabledClass);

    useEffect(() => {
        applyPermission(topAndLeftMenuData);
    }, [topAndLeftMenuData]);
    // useEffect(() => {
    //   if (state.permissions && state.permissions.View) {
    //     setLoading(false); // Update loading state once permissions are available
    //   }
    // }, [state.permissions]);
    /**
    * @method applyPermission
    * @description ACCORDING TO PERMISSION HIDE AND SHOW, ACTION'S
    */
    const applyPermission = (topAndLeftMenuData) => {
        if (topAndLeftMenuData !== undefined) {
            const Data = topAndLeftMenuData && topAndLeftMenuData.find(el => el.ModuleName === REGISTRATION_FORM_KYS2);
            const accessData = Data && Data.Pages.find(el => el.PageName === PENDING_FOR_APPROVAL_KYS2_LIST)
            const permmisionData = accessData && accessData.Actions && checkPermission(accessData.Actions)

            if (permmisionData !== undefined) {
                setState(prevState => ({
                    ...prevState,
                    permissions: permmisionData,
                    ViewAccessibility: permmisionData && permmisionData.View ? permmisionData.View : false,
                    AddAccessibility: permmisionData && permmisionData.Add ? permmisionData.Add : false,
                    EditAccessibility: permmisionData && permmisionData.Edit ? permmisionData.Edit : false,
                    DeleteAccessibility: permmisionData && permmisionData.Delete ? permmisionData.Delete : false,
                    DownloadAccessibility: permmisionData && permmisionData.Download ? permmisionData.Download : false,
                }))
            }

        }
    }

    /**
    * @method toggle
    * @description toggling the tabs
    */
    const toggle = (tab) => {

        if (state.activeTab !== tab) {
            setState(prevState => ({
                ...prevState,

                activeTab: tab,
                stopApiCallOnCancel: false
            }));
        }
        // dispatch(setSelectedRowForPagination([])); // Dispatch action using useDispatch hook
    }

    return (
        <>
            <div className="container-fluid h-100 hl-cstm-loader-height" id='go-to-top'>
                {/* {loading && <LoaderCustom />} */}
                <ScrollToTop pointProp="go-to-top" />

                <Row>
                    <Col>
                        {(Object.keys(state.permissions).length > 0 || props?.isDelegated) && (

                            <div>{!props?.isDelegated &&
                                <Nav tabs className="subtabs mt-0 p-relative">
                                    {disabledClass && <div title={MESSAGES.DOWNLOADING_MESSAGE} className="disabled-overflow"></div>}
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: state.activeTab === "1",
                                            })}
                                            onClick={() => {
                                                toggle("1");
                                            }}
                                        >
                                            Pending For Approval KYS 2 List
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: state.activeTab === "2",
                                            })}
                                            onClick={() => {
                                                toggle("2");
                                            }}
                                        >
                                            Awaiting Approval
                                        </NavLink>
                                    </NavItem>
                                </Nav>}
                                <ApplyPendingForKys2.Provider value={state.permissions}>

                                    <TabContent activeTab={state.activeTab}>
                                        {state.activeTab === '1' && (
                                            <TabPane tabId="1">
                                                <PendingForApprovalKys2ListTab
                                                    // formToggle={displayOverheadForm}
                                                    // getDetails={getOverHeadDetails}
                                                    AddAccessibility={state.AddAccessibility}
                                                    EditAccessibility={state.EditAccessibility}
                                                    DeleteAccessibility={state.DeleteAccessibility}
                                                    DownloadAccessibility={state.DownloadAccessibility}
                                                    ViewAccessibility={state.ViewAccessibility}
                                                    stopApiCallOnCancel={state.stopApiCallOnCancel}
                                                    isDelegated={props?.isDelegated}
                                                />
                                            </TabPane>
                                        )}

                                        {state.activeTab === '2' && (
                                            <TabPane tabId="2">
                                                <AwaitingForApprovalListTab
                                                    // formToggle={displayProfitForm}
                                                    // getDetails={getProfitDetails}
                                                    AddAccessibility={state.AddAccessibility}
                                                    EditAccessibility={state.EditAccessibility}
                                                    DeleteAccessibility={state.DeleteAccessibility}
                                                    DownloadAccessibility={state.DownloadAccessibility}
                                                    ViewAccessibility={state.ViewAccessibility}
                                                    stopApiCallOnCancel={state.stopApiCallOnCancel}
                                                />
                                            </TabPane>
                                        )}
                                    </TabContent>
                                </ApplyPendingForKys2.Provider>
                            </div>
                        )}
                    </Col>
                </Row>
            </div>
        </>
    );

}
export default PendingListKy2

